<template>
  <div id="auth" class="text-center animated fadeIn fast">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "Auth"
};
</script>

<style scoped>
#auth {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/images/login_bg.png");
  background-position: top center;
  background-attachment: fixed;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
